export const STAFF = 'staff';
export const PARENT = 'parent';
export const STUDENT = 'student';

export const SUPER_ADMIN = 'super admin';
export const BRANCH_ADMIN = 'branch admin';
export const ACCOUNTANT = 'accountant';
export const FRONT_OFFICE = 'front office';
export const FACULTY = 'faculty';
export const COUNSELOR = 'counselor';

export type Roles = 'staff' | 'parent' | 'student';

export type StaffRoles =
  | 'super admin'
  | 'branch admin'
  | 'accountant'
  | 'front office'
  | 'faculty'
  | 'counselor';
